module.exports = __webpack_public_path__ + "img/phone-album.1117d36d.webp";